import { isSuccess } from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { WarehouseSetup } from '@/models/map'
import { cartSlice } from '../cartSlice'
import { mapSlice } from '../mapSlice'

export const warehouseSelectedElementAvailabilitySelector = createSelector(
  [
    mapSlice.selectors.warehouse,
    cartSlice.selectors.selectedElementReservation,
    cartSlice.selectors.cartReservations,
  ],
  (warehouse, selectedElementReservation, cartReservations): WarehouseSetup => {
    if (!isSuccess(warehouse) || !selectedElementReservation) {
      return {
        beds: 0,
        chairs: 0,
        deckChairs: 0,
        maxiBeds: 0,
      }
    }

    // check if there is availability in the warehouse
    if (!warehouse.value[selectedElementReservation.sectorId]) {
      return {
        beds: Infinity,
        chairs: Infinity,
        deckChairs: Infinity,
        maxiBeds: Infinity,
      }
    }

    const availability = {
      ...warehouse.value[selectedElementReservation.sectorId],
    }

    cartReservations.forEach((r) => {
      // skip selected reservation or reservations for different sectors
      if (
        (r.spotName === selectedElementReservation.spotName &&
          r.spotType === selectedElementReservation.spotType) ||
        r.sectorId !== selectedElementReservation.sectorId
      ) {
        return
      }

      availability.beds -= r.beds
      availability.chairs -= r.chairs
      availability.deckChairs -= r.deckChairs
      availability.maxiBeds -= r.maxiBeds
    })

    availability.beds -= selectedElementReservation.beds
    availability.chairs -= selectedElementReservation.chairs
    availability.deckChairs -= selectedElementReservation.deckChairs
    availability.maxiBeds -= selectedElementReservation.maxiBeds

    return availability
  }
)
